import { render, staticRenderFns } from "./clothSheet.vue?vue&type=template&id=30544bd6&scoped=true"
import script from "./clothSheet.vue?vue&type=script&lang=js"
export * from "./clothSheet.vue?vue&type=script&lang=js"
import style0 from "./clothSheet.vue?vue&type=style&index=0&id=30544bd6&prod&lang=scss&scoped=true"
import style1 from "./clothSheet.vue?vue&type=style&index=1&id=30544bd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30544bd6",
  null
  
)

export default component.exports